import React from 'react';
import {
  AccessPermitPoolingGroupCombinedInfo,
  Maybe,
} from 'types/generatedSchemaTypes';
import { getPoolingGroupPaymentInfoText } from 'utils/permitUtils';
import PermitTicketHeader from '../PermitTicketHeader';

type HeaderViewProps = {
  poolingGroup: Maybe<AccessPermitPoolingGroupCombinedInfo> | undefined;
};

export const PoolingGroupHeader: React.FC<HeaderViewProps> = ({
  poolingGroup,
}) => {
  return (
    <PermitTicketHeader
      title={
        (poolingGroup?.parkingZoneName || poolingGroup?.salesLocationName) ?? ''
      }
      subtitle={getPoolingGroupPaymentInfoText(poolingGroup)}
      usePinIcon={true}
      additionalTitle={poolingGroup?.pmcName || undefined}
    />
  );
};
